import React, { useState, useRef, useEffect } from 'react';

export default function CustomerSearch({ customers = [], value, onChange, onSelect, placeholder = 'Buyer name', required = false }) {
  const [open, setOpen] = useState(false);
  const containerRef    = useRef(null);

  // Close dropdown on outside click
  useEffect(() => {
    const handler = (e) => { if (!containerRef.current?.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const q = (value || '').trim().toLowerCase();
  const filtered = q
    ? customers.filter(c =>
        (c.name || '').toLowerCase().includes(q) ||
        (c.contact || '').toLowerCase().includes(q))
    : customers;

  // Nothing left to pick once the typed name exactly matches the only suggestion.
  const exact = filtered.length === 1 && (filtered[0].name || '').trim().toLowerCase() === q;

  const handleSelect = (c) => {
    setOpen(false);
    onSelect(c);
  };

  return (
    <div ref={containerRef} style={{ position: 'relative' }}>
      <input
        type="text"
        value={value}
        onChange={(e) => { onChange(e.target.value); setOpen(true); }}
        onFocus={() => setOpen(true)}
        placeholder={placeholder}
        required={required}
        style={{ width: '100%' }}
        autoComplete="off"
      />

      {open && filtered.length > 0 && !exact && (
        <div style={{
          position: 'absolute', top: 'calc(100% + 4px)', left: 0, right: 0,
          background: 'var(--color-surface)', border: '1px solid var(--color-border)',
          borderRadius: 'var(--radius-sm)', zIndex: 50, maxHeight: '200px', overflowY: 'auto',
          boxShadow: '0 4px 16px rgba(0,0,0,0.3)',
        }}>
          {filtered.map(c => (
            <div
              key={c.id}
              onMouseDown={() => handleSelect(c)}
              style={{
                padding: '0.6rem 0.85rem', cursor: 'pointer', fontSize: '0.88rem',
                borderBottom: '1px solid var(--color-border)',
              }}
              onMouseEnter={e => e.currentTarget.style.background = 'var(--color-surface2)'}
              onMouseLeave={e => e.currentTarget.style.background = ''}
            >
              <span style={{ fontWeight: 500 }}>{c.name}</span>
              {c.contact && (
                <span style={{ float: 'right', fontSize: '0.75rem', color: 'var(--color-muted)' }}>
                  {c.contact}
                </span>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
